module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_5.cae8b188.png";